<template>
        <b-modal :no-close-on-backdrop="true" :no-close-on-esc="true"  :static="true" :size="size" :title="caption" v-model="dataShow" :hide-footer="true">
            <CreateAccount @onLoginClick="onLoginClick">
                <slot slot="beforeFormButtons">
                    <b-button @click="dataShow = false" class="btn btn-light">{{Core.Definition.getDefinition('Annuler')}}</b-button>
                </slot>
            </CreateAccount>
        </b-modal>
</template>

<script>
    import CreateAccount from './CreateAccount'
    export default {
        name: 'ModalCreateAccount',
        components: {
            CreateAccount
        },
        props: {
            size: {
                type: String,
                default: 'm'
            },
            caption: {
                type: String,
                default: ''
            }
        },
        watch: {},
        mounted() {
        },
        data: () => {
            return {
                Core: window.Core,
                dataShow: false
            }
        },
        computed: {
            open: {
                set(val) {
                    this.dataShow = val
                },
                get() {
                    return this.dataShow
                }
            },
        },
        methods: {
            onLoginClick(status) {
                this.$emit('onLoginClick', status)
            }
        }
    }
</script>